import type { GradeLevel } from "@markeroo/shared";

/**
 * Data structure passed from StudentFormModal on submit.
 * Used by both ClassDetailPage and AssignmentDetailPage.
 */
export interface StudentFormData {
  name: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  elaGradeLevel?: GradeLevel;
  notes: string;
  isEll: boolean;
}

/**
 * Builds the API payload for student update/create operations.
 * Handles null coercion for notes field.
 */
export function buildStudentPayload(data: StudentFormData) {
  return {
    name: data.name,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    elaGradeLevel: data.elaGradeLevel,
    notes: data.notes || null,
    isEll: data.isEll,
  };
}
